import I18nForLwText from './LwText'

export default class I18nForLwAutoComplete extends I18nForLwText {
  name = 'lw-auto-complete'
}
